import { useState } from "react"

import { Button, SlackIcon } from "@productlane/ui"

import { env } from "@/env"

export function ConnectSlackButton() {
	const [isLoading, setIsLoading] = useState(false)

	return (
		<Button
			isLoading={isLoading}
			onClick={() => {
				setIsLoading(true)
				window.location.href = `${env.VITE_API_URL}/api/auth/slack?state=personal-notifications`
			}}
			variant="outline"
			Icon={SlackIcon}
		>
			Connect Slack
		</Button>
	)
}
